<div class="content-page">
  <img src="/assets/images/robot.svg" alt="Unauthorized" />
  <h4>We are sorry..!</h4>
  <h6>You don’t have permissions to access this page.</h6>
</div>
